// extracted by mini-css-extract-plugin
export default {"container":"Card_menu_container__CNCdr","col":"Card_menu_col__5bqyK","colIcon":"Card_menu_colIcon__KnZtE"};